/**
 * @returns {RegExp}
 */
function accountNo () {
  return /([0-9]{1,5})-([0-9]{6,10})\b/g
}

module.exports = { accountNo }
